import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * CartazPontuais
 * Cartaz A6 profissional para impressao com QR Code para Tarefas Pontuais
 * Tamanho A6: 105mm x 148mm
 * URL fixo: https://samidel.app/tarefas-pontuais
 */
export default function CartazPontuais() {
  const qrUrl = 'https://samidel.app/tarefas-pontuais';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200 p-4 print:p-0 print:bg-white">
      {/* Botao de impressao */}
      <button
        onClick={() => window.print()}
        className="fixed top-4 right-4 px-6 py-3 bg-[#0B3B30] text-white font-bold rounded-xl shadow-lg hover:bg-[#0a3028] transition-all print:hidden z-50"
        data-testid="btn-imprimir-cartaz"
      >
        Imprimir Cartaz
      </button>

      {/* Cartaz A6 */}
      <div
        className="bg-white shadow-2xl print:shadow-none flex flex-col items-center"
        style={{
          width: '105mm',
          height: '148mm',
          padding: '0',
          boxSizing: 'border-box',
          overflow: 'hidden',
        }}
        data-testid="cartaz-a6"
      >
        {/* Barra superior verde */}
        <div style={{
          width: '100%',
          height: '4mm',
          background: 'linear-gradient(90deg, #0B3B30 0%, #14654f 100%)',
          flexShrink: 0,
        }} />

        {/* Conteudo */}
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '5mm 8mm 4mm 8mm',
          width: '100%',
          boxSizing: 'border-box',
        }}>
          {/* Logo Samidel - grande e visivel */}
          <div style={{ marginBottom: '2mm', textAlign: 'center' }}>
            <img
              src="/samidel-logo-new.png"
              alt="Samidel Textiles"
              style={{ height: '28mm', objectFit: 'contain' }}
              data-testid="cartaz-logo"
            />
          </div>

          {/* Separador fino */}
          <div style={{
            width: '60mm',
            height: '0.4mm',
            background: '#0B3B30',
            marginBottom: '3mm',
            opacity: 0.3,
          }} />

          {/* Titulo */}
          <h1
            style={{
              textAlign: 'center',
              fontWeight: 900,
              textTransform: 'uppercase',
              letterSpacing: '2px',
              fontSize: '15pt',
              color: '#0B3B30',
              lineHeight: 1.1,
              margin: '0 0 1.5mm 0',
            }}
          >
            Tarefas Pontuais
          </h1>

          {/* Subtitulo */}
          <p
            style={{
              textAlign: 'center',
              fontSize: '8pt',
              color: '#64748B',
              margin: '0 0 3mm 0',
              fontWeight: 500,
            }}
          >
            Leia o codigo QR para aceder as suas tarefas
          </p>

          {/* QR Code com moldura */}
          <div
            style={{
              padding: '3mm',
              border: '0.5mm solid #0B3B30',
              borderRadius: '3mm',
              marginBottom: '3mm',
              background: '#fff',
            }}
            data-testid="qr-code-pontuais"
          >
            <QRCodeSVG
              value={qrUrl}
              size={140}
              level="H"
              includeMargin={false}
              fgColor="#0B3B30"
              bgColor="#FFFFFF"
            />
          </div>

          {/* Instrucoes compactas */}
          <div
            style={{
              background: '#F0FDF4',
              border: '0.3mm solid #BBF7D0',
              borderRadius: '2mm',
              padding: '2mm 3mm',
              width: '100%',
              marginBottom: '2mm',
              textAlign: 'center',
            }}
          >
            <p style={{ fontSize: '6.5pt', color: '#166534', lineHeight: 1.4, margin: 0 }}>
              <strong>1.</strong> Abra a app no telemovel &nbsp;
              <strong>2.</strong> Toque no icone QR &nbsp;
              <strong>3.</strong> Aponte para este codigo
            </p>
          </div>

          {/* Rodape */}
          <div style={{ textAlign: 'center', marginTop: 'auto' }}>
            <p style={{ fontSize: '5.5pt', color: '#94A3B8', lineHeight: 1.3, margin: 0 }}>
              samidel.app &bull; Sistema de Gestao de Producao
            </p>
          </div>
        </div>

        {/* Barra inferior verde */}
        <div style={{
          width: '100%',
          height: '3mm',
          background: 'linear-gradient(90deg, #14654f 0%, #0B3B30 100%)',
          flexShrink: 0,
        }} />
      </div>

      {/* CSS de impressao */}
      <style>{`
        @media print {
          @page {
            size: 105mm 148mm;
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
          }
          .print\\:hidden {
            display: none !important;
          }
          .print\\:shadow-none {
            box-shadow: none !important;
          }
          .print\\:p-0 {
            padding: 0 !important;
          }
          .print\\:bg-white {
            background: white !important;
          }
        }
      `}</style>
    </div>
  );
}
